export default {
    //地址选择器数据处理 这里处理的是二级数据 因为ui奇葩
    getAddress(_this) {
        let that = _this
        let addressList = [];
        return new Promise(function (resolve, reject) {
            that.$http.get("https://pro-core.babycdn.com/2021/aosmith/lottery/china.json").then(res => {
                if (res.body.error == 0) {
                    var addressData = res.body.data.result;
                    //console.log(addressData)
                    let objprovinces = addressData[0]
                    objprovinces.forEach(item => {
                        if (item.id != 0) {
                            //console.log(item)
                            //处理前
                            let city = addressData[item.id]
                            //console.log(city)
                            //处理后
                            let city2 = []
                            city.forEach(cityItem => {
                                city2.push({ value: cityItem.name, id: cityItem.id })
                            })
                            addressList.push({
                                value: item.name,
                                id: item.id,
                                children: city2
                            })
                        }
                    });
                    //console.log(addressList)
                    resolve({ city: addressList, original: addressData });
                }
            })
        })
    },
    //把区域处理成选择器需要的格式
    getArea(val){
        //console.log(val)
        let addressList = [];
        val.forEach(item => {
            if (item.id != 0) {
                addressList.push({value:item.name,id:item.id})
            }
        })
        return addressList;
    }
}